import React from 'react';
import './App.css';
import './index.css';
import HomeRoutes from './routes';


function App() {
  return (
   <HomeRoutes/>
  );
}

export default App;
